import closeIcon from 'assets/close-icon.png';
import minusIcon from 'assets/minus-circle-white.svg';
import plusIcon from 'assets/plus-circle-white.svg';
import classnames from 'classnames';
import Slider, { Handle } from 'rc-slider';
import 'rc-slider/assets/index.css';
import React, { useState } from 'react';
import './ZoomImageModal.scss';

const ZOOM_POINT_50 = 50;
const ZOOM_POINT_100 = 100;
const ZOOM_POINT_160 = 160;

type Props = {
  closeModal: () => void;
  displayImageSrc: string;
  fileName: string;
  personName: string;
  avatarImageSrc?: string;
  date?: string;
  zIndex?: number;
};

export const ZoomImageModal = (props: Props) => {
  const {
    displayImageSrc,
    avatarImageSrc,
    fileName,
    personName,
    date,
    closeModal,
    zIndex,
  } = props;

  const [imageZoom, setImageZoom] = useState(ZOOM_POINT_100);

  const classList = classnames('zoom-image-modal__body-image', {
    'zoom-image-modal__body-image--minus': imageZoom >= ZOOM_POINT_160,
  });

  const toggleIsZoomIn = () => {
    if (imageZoom >= ZOOM_POINT_50 && imageZoom < ZOOM_POINT_100) {
      setImageZoom(ZOOM_POINT_100);
    } else if (imageZoom >= ZOOM_POINT_100 && imageZoom < ZOOM_POINT_160) {
      setImageZoom(ZOOM_POINT_160);
    } else {
      setImageZoom(ZOOM_POINT_100);
    }
  };

  const handle = props => {
    const { value } = props;
    return (
      <Handle
        className="zoom-image-modal__header-image-slider"
        {...props}
        style={{
          backgroundColor: 'white',
          color: '#525252',
          width: '40px',
          height: '18px',
          border: 'none',
          borderRadius: '15px',
          fontSize: '12px',
          fontWeight: 'bold',
          paddingRight: '4px',
          paddingLeft: '4px',
          textAlign: 'center',
        }}
      >
        {value}%
      </Handle>
    );
  };

  return (
    <div className="zoom-image-modal" style={{ zIndex }}>
      <div className="zoom-image-modal__header">
        <div className="zoom-image-modal__header-image-info">
          {avatarImageSrc && (
            <img
              alt="avatar"
              className="zoom-image-modal__header-avatar"
              src={avatarImageSrc}
            />
          )}
          <div>
            <p className="zoom-image-modal__header-image-info-name">
              {fileName}
            </p>
            {personName && date && (
              <span>
                {personName}; {date}
              </span>
            )}
          </div>
        </div>
        <div className="zoom-image-modal__header-slider-buttons-container">
          <img
            alt="minus"
            src={minusIcon}
            onClick={() => {
              setImageZoom(imageZoom - 5);
            }}
          />
          <div className="zoom-image-modal__header-slider-wrapper">
            <Slider
              min={50}
              max={230}
              value={imageZoom}
              step={5}
              handle={handle}
              railStyle={{ backgroundColor: '#D5D5D5' }}
              trackStyle={{ backgroundColor: '#D5D5D5' }}
              onChange={v => {
                setImageZoom(v);
              }}
            />
          </div>
          <img
            alt="plus"
            src={plusIcon}
            onClick={() => {
              setImageZoom(imageZoom + 5);
            }}
          />
        </div>
        <div className="zoom-image-modal__header-close-icon-wrapper">
          <img
            alt="close"
            src={closeIcon}
            onClick={closeModal}
            className="zoom-image-modal__header-close-icon"
          />
        </div>
      </div>
      <div className="zoom-image-modal__body">
        <div
          className="zoom-image-modal__body-image-wrapper"
          style={{ width: `${imageZoom * 6.5}px` }}
        >
          <img
            alt="message"
            className={classList}
            src={displayImageSrc}
            onClick={toggleIsZoomIn}
          />
        </div>
      </div>
    </div>
  );
};
